module.exports = __webpack_public_path__ + "img/img10.8bd5426a.png";